<style lang="scss" scoped>
.slide-8 {
  background-image: url(../../../assets/module1/slide8/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 60px;
  height: calc(100% - 60px);
  display: flex;
  padding-right: 200px;
  flex-direction: column;
  align-items: flex-end;
}
h1 {
  font-size: 134px;
  color: #68378d;
  transform: rotate(-4deg);
}
h2 {
  font-size: 80px;
  text-align: right;
  margin-bottom: 30px;
}
p {
  color: white;
  margin-bottom: 1em;
  max-width: 477px;
  margin-right: 95px;
  &:first-of-type {
    max-width: 791px;
    margin-right: 65px;
  }
}
</style>

<template>
  <div class="slide-8">
    <transition name="fadeLeft" appear>
      <img
        src="@/assets/module1/slide8/photos-01.png"
        v-show="slideIndex == 7"
        class="delay-5 chars"
      />
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 7">
        <h1>{{ $t("module1.slide8.heading") }}</h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <h2
        class="delay-1"
        v-show="slideIndex == 7"
        v-html="$t('module1.slide8.heading2')"
      ></h2>
    </transition>
    <transition name="fadeUp" appear>
      <p class="delay-2" v-show="slideIndex == 7">
        {{ $t("module1.slide8.paragraph") }}
      </p>
    </transition>
    <transition name="fadeUp" appear>
      <p class="delay-3" v-show="slideIndex == 7">
        {{ $t("module1.slide8.paragraph2") }}
      </p>
    </transition>
    <transition name="fadeUp" appear>
      <p class="delay-4" v-show="slideIndex == 7">
        {{ $t("module1.slide8.paragraph3") }}
      </p>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
